import React from 'react';
import GridImage from './GridImage';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const ValsalvaProjectGrid = (props) => {
    let currentProjectIndex = props.projects.findIndex(project => project.path === props.path);
    let gridImages = props.projects[currentProjectIndex].gridImages;
    return (
        <div>
            <div className="project-slide"></div>
            <div className="project-grid valsalva-project container">
                <div className="flex">
                    {/*<img className="grid-img-1" src="/assets/img/homes/valsalva/03.jpg" alt=""/>*/}
                    <GridImage params={{className: 'grid-img-1', asset: gridImages[1], sizes: ''}}/>
                    <div className="grid-col-1">
                        {/*<img className="grid-img-2" src="/assets/img/homes/valsalva/02.jpg" alt=""/>*/}
                        <GridImage params={{className: 'grid-img-2', asset: gridImages[2], sizes: ''}}/>
                        <svg className="grid-svg-1" x="0px" y="0px" width="300" height="800" viewBox="0 0 300 800">
                            <text className="barlow-re" x="0" y="8" fill="#000">
                                <tspan x="0">v</tspan>
                                <tspan x="0" dy="113">a</tspan>
                                <tspan x="0" dy="113">l</tspan>
                                <tspan x="0" dy="113">s</tspan>
                                <tspan x="0" dy="113">a</tspan>
                                <tspan x="0" dy="113">l</tspan>
                                <tspan x="0" dy="113">v</tspan>
                                <tspan x="0" dy="113">a</tspan>
                            </text>
                            <text className="barlow-re" x="0" y="8" fill="#000">
                                <tspan x="72">v</tspan>
                                <tspan x="72" dy="94">a</tspan>
                                <tspan x="72" dy="94">l</tspan>
                                <tspan x="72" dy="94">s</tspan>
                                <tspan x="72" dy="94">a</tspan>
                                <tspan x="72" dy="94">l</tspan>
                                <tspan x="72" dy="94">v</tspan>
                                <tspan x="72" dy="94">a</tspan>
                            </text>
                            <text className="barlow-re" x="0" y="8" fill="#000">
                                <tspan x="144">v</tspan>
                                <tspan x="144" dy="54">a</tspan>
                                <tspan x="144" dy="54">l</tspan>
                                <tspan x="144" dy="54">s</tspan>
                                <tspan x="144" dy="54">a</tspan>
                                <tspan x="144" dy="54">l</tspan>
                                <tspan x="144" dy="54">v</tspan>
                                <tspan x="144" dy="54">a</tspan>
                            </text>
                            <text className="barlow-re" x="0" y="8" fill="#000">
                                <tspan x="218">v</tspan>
                                <tspan x="218" dy="24">a</tspan>
                                <tspan x="218" dy="24">l</tspan>
                                <tspan x="218" dy="24">s</tspan>
                                <tspan x="218" dy="24">a</tspan>
                                <tspan x="218" dy="24">l</tspan>
                                <tspan x="218" dy="24">v</tspan>
                                <tspan x="218" dy="24">a</tspan>
                            </text>
                            <text className="barlow-re" x="0" y="8" fill="#000">
                                <tspan x="288">v</tspan>
                                <tspan x="288" dy="194">a</tspan>
                                <tspan x="288" dy="194">l</tspan>
                                <tspan x="288" dy="194">s</tspan>
                                <tspan x="288" dy="194">a</tspan>
                                <tspan x="288" dy="194">l</tspan>
                                <tspan x="288" dy="194">v</tspan>
                                <tspan x="288" dy="194">a</tspan>
                            </text>
                        </svg>
                    </div>
                </div>
                {/*<img className="grid-img-3" src="/assets/img/homes/valsalva/04.jpg" alt=""/>*/}
                <GridImage params={{className: 'grid-img-3', asset: gridImages[3], sizes: ''}}/>
                <div className="flex">
                    {/*<img className="grid-img-4" src="/assets/img/homes/valsalva/05.jpg" alt=""/>*/}
                    <GridImage params={{className: 'grid-img-4', asset: gridImages[4], sizes: ''}}/>
                    <div className="grid-col-2">
                        <svg className="grid-svg-2" x="0px" y="0px" width="576" height="656" viewBox="0 0 576 656">
                            <text className="barlow-me-it" x="0" y="8" fill="#af2100">
                                <tspan x="0">a</tspan>
                                
                                <tspan x="0" dy="54">a</tspan>
                                
                                <tspan x="0" dy="54">a</tspan>
                                <tspan x="0" dx="17">a</tspan>
                                <tspan x="0" dx="34">a</tspan>

                                <tspan x="0" dy="54">a</tspan>
                                <tspan x="0" dx="17">a</tspan>
                                <tspan x="0" dx="48">a</tspan>

                                <tspan x="0" dy="54">a</tspan>
                                
                                <tspan x="0" dy="54">a</tspan>
                                <tspan x="0" dx="17">a</tspan>

                                <tspan x="0" dy="54">a</tspan>

                                <tspan x="0" dy="54">a</tspan>

                                <tspan x="0" dy="54">a</tspan>
                                <tspan x="0" dx="17">a</tspan>
                                <tspan x="0" dx="48">a</tspan>

                                <tspan x="0" dy="54">a</tspan>
                                
                                <tspan x="0" dy="54">a</tspan>
                                
                                <tspan x="0" dy="54">a</tspan>

                                <tspan x="0" dy="54">a</tspan>
                                <tspan x="0" dx="17">a</tspan>
                            </text>
                            <text className="barlow-me-it" x="0" y="8" fill="#000">
                                <tspan x="570">a</tspan>

                                <tspan x="570" dy="54">a</tspan>
                                <tspan x="570" dx="-17">a</tspan>
                                <tspan x="570" dx="-34">a</tspan>

                                <tspan x="570" dy="54">a</tspan>
                                
                                <tspan x="570" dy="54">a</tspan>

                                <tspan x="570" dy="54">a</tspan>
                                <tspan x="570" dx="-17">a</tspan>

                                <tspan x="570" dy="54">a</tspan>
                                <tspan x="570" dx="-17">a</tspan>
                                <tspan x="570" dx="-49">a</tspan>

                                <tspan x="570" dy="54">a</tspan>
                                <tspan x="570" dx="-31">a</tspan>

                                <tspan x="570" dy="54">a</tspan>
                                <tspan x="570" dx="-17">a</tspan>

                                <tspan x="570" dy="54">a</tspan>

                                <tspan x="570" dy="54">a</tspan>

                                <tspan x="570" dy="54">a</tspan>

                                <tspan x="570" dy="54">a</tspan>

                                <tspan x="570" dy="54">a</tspan>
                            </text>
                        </svg>
                        {/*<img className="grid-img-5" src="/assets/img/homes/valsalva/06.jpg" alt=""/>*/}
                        <GridImage params={{className: 'grid-img-5', asset: gridImages[5], sizes: ''}}/>
                    </div>
                </div>
                <div className="flex credits-container">
                    <div className="credits desktop">
                        <span className="credits-title red">Credits</span>
                        <ul className="no-style">
                            <li><span className="red barlow-me">Project</span> Valsalva</li>
                            <li><span className="red barlow-me">Photographer</span> Benoit Meignan</li>
                            <li><span className="red barlow-me">Art Director</span> Jane Brizard<br/>& Benoit Meignan</li>
                            <li><span className="red barlow-me">Hair / Coiffure</span> Jane Brizard</li>
                            <li><span className="red barlow-me">Makeup / Maquillage</span> Jane Brizard</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

// export default ValsalvaProjectGrid;
const mapStateToProps = (state) => {
    return {
        projects: state.assets.projects
    };
};

export default withRouter(connect(mapStateToProps, null)(ValsalvaProjectGrid));


// WEBPACK FOOTER //
// ./src/components/ValsalvaProjectGrid.js